Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DProfile = module.exports.default = {
	BASELINE: "baseline",
	BASELINE_CONSTRAINED: "baselineConstrained",
	BASELINE_EXTENDED: "baselineExtended",
	STANDARD: "standard",
	STANDARD_CONSTRAINED: "standardConstrained",
	STANDARD_EXTENDED: "standardExtended"
};